import { render } from "./StationDetailsHeader.vue?vue&type=template&id=112711c3"
import script from "./StationDetailsHeader.vue?vue&type=script&lang=js"
export * from "./StationDetailsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__